// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ql-code-block,\n.ql-image,\n.ql-video,\n.ql-formats:nth-child(4) {\n  display: none !important;\n}\n", ""]);
// Exports
module.exports = exports;
